import react, { Fragment, useState, useEffect } from 'react'
import axios from 'axios'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import 'react-datepicker/dist/react-datepicker.css'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { FaCalendarAlt } from 'react-icons/fa'
import dayjs from 'dayjs'
import html2pdf from 'html2pdf.js'
import $ from 'jquery'
import SideNavbarStudentReg from './SideNavbarStudentReg'
import NavBarStudentReg from './NavBarStudentReg'
import afterlogo from './login-after.png'
import qrcode from './JainBoardingNewQR.jpeg'
import loadingImg from '../Assets/loading.gif'
import './SideNavbarStudentReg.css'
import { Col, Form, FormControl, Row, Spinner } from 'react-bootstrap'
import { Button, DatePicker, Input, Select } from 'antd'

import logo from '../studentDashboard/img/logo2.png'
import logo2 from '../studentDashboard/img/logonew.jpg'
import studentPhoto from '../studentDashboard/img/StudentPic.png'
import parentsPhoto from '../studentDashboard/img/ParentsPhoto.png'
import {
  DistrictFindAllApi,
  DocumentAddApi,
  DocumentFindOneApi,
  ImagePath,
  RegristrationAddApi,
  StateFindAllApi,
  SubCateroryFindAllApi,
  TalukaFindAllApi,
  TermFindAllApi,
  RegistrationAddNewApi,
} from '../ApiFile'
import { ThreeDots } from 'react-loader-spinner'
// Register fonts
pdfMake.vfs = pdfFonts.pdfMake.vfs

const toDataURL = (url) =>
  fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        }),
    )

const RegForm = () => {
  const [date, setDate] = useState()
  const formattedDate = dayjs(date).format('DD/MM/YYYY')

  const [Sfname, setSfname] = useState('')
  const [Smname, setSmname] = useState('')
  const [Slname, setSlname] = useState('')
  // const [Ffname, setFfname] = useState("");
  const [Fmname, setFmname] = useState('')
  // const [Flname, setFlname] = useState("");

  const [Village, setVillage] = useState('')
  const [House, setHouse] = useState('')
  const [Pin, setPin] = useState('')
  const [SubCategory, setSubCategory] = useState('')

  const [adharNo, setAdharNo] = useState('')
  const [Smobile, setSmobile] = useState('')
  const [Pmobile, setPmobile] = useState('')
  const [bloodGroup, setBloodGroup] = useState('')
  const [age, setAge] = useState('')
  const [FOccupation, setFOccupation] = useState('')
  const [email, setEmail] = useState('')

  const [PCollageName, setPCollageName] = useState('')
  const [StdDiv, setStdDiv] = useState('')
  const [CurrentStd, setCurrentStd] = useState('')
  const [CCollageName, setCCollageName] = useState('')
  const [Profeciency, setProfeciency] = useState('')
  const [Fellowship, setFellowship] = useState('')

  const [MedicalIssue, setMedicalIssue] = useState('')
  const [MedicalIssueDescription, setMedicalIssueDescription] = useState('')
  const [Disability, setDisability] = useState('')
  const [DisabilityDescription, setDisabilityDescription] = useState('')

  const [PHostelAddress, setPHostelAddress] = useState('')
  const [PHostelName, setPHostelName] = useState('')
  const [Duration, setDuration] = useState('')

  const [adharCard, setAdharCard] = useState(null)
  const [photo, setPhoto] = useState(null)
  const [markList, setMarkList] = useState(null)
  const [proficiencyDoc, setProficiencyDoc] = useState(null)
  const [parentPhoto, setParentPhoto] = useState(null)
  const [tax, setTax] = useState(null)
  const [taxId, setTaxid] = useState('')
  const [paymentMode, setPaymentMode] = useState('')

  const [stateList, setStateList] = useState([])
  const [rules, setRules] = useState([])
  const [districtList, setDistrictList] = useState([])
  const [talukaList, setTalukaList] = useState([])
  const [selectedState, setSelectedState] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')
  const [selectedTaluka, setSelectedTaluka] = useState('')

  const [subCategories, setSubCategories] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [warning, setWarning] = useState('')
  const [warning1, setWarning1] = useState('')
  const [warning2, setWarning2] = useState('')
  const [selectedSubCategory, setSelectedSubCategory] = useState('')
  const [inputValid, setInputValid] = useState(false)

  const [errors, setErrors] = useState({}) // Define errors state variable
  const [taxidError, setTaxidError] = useState('')
  const [paymentModeError, setpaymentModeError] = useState('')
  const [taxError, setTaxError] = useState('')
  const navigate = useNavigate()

  const [logoBase64, setLogoBase64] = useState(null)
  const [logo2Base64, setLogo2Base64] = useState(null)
  const [logo3Base64, setLogo3Base64] = useState(null)
  const [parentPhotoBase64, setParentPhotoBase64] = useState(null)

  useEffect(() => {
    fetchRuleData()
  }, [])

  const fetchRuleData = async () => {
    try {
      const response = await fetch(TermFindAllApi)
      if (!response.ok) {
        throw new Error('Failed to fetch block data')
      }
      const data = await response.json()
      if (data === 'NOTFOUND') {
        setRules([]) // Set rules to an empty array if "NOTFOUND"
      } else {
        setRules(data)
      }
    } catch (error) {
      // console.error('Error fetching block data:', error);
    }
  }

  useEffect(() => {
    // Fetch the list of states from the API
    axios
      .get(StateFindAllApi)
      .then((response) => {
        setStateList(response.data)
      })
      .catch((error) => {
        // console.error("Error fetching state list:", error);
      })
  }, [])

  useEffect(() => {
    if (selectedState !== '') {
      axios
        .get(`${DistrictFindAllApi}/${selectedState}`)
        .then((response) => {
          setDistrictList(response.data)
        })
        .catch((error) => {
          // console.error("Error fetching district list:", error);
        })
    }
  }, [selectedState])

  useEffect(() => {
    // Fetch the list of talukas based on the selected state and district
    if (selectedState !== '' && selectedDistrict !== '') {
      axios
        .get(`${TalukaFindAllApi}/${selectedState}/${selectedDistrict}`)
        .then((response) => {
          setTalukaList(response.data)
        })
        .catch((error) => {
          // console.error("Error fetching taluka list:", error);
        })
    }
  }, [selectedState, selectedDistrict])

  const handleStateChange = (e) => {
    setSelectedState(e.target.value)
    setSelectedDistrict('')
    setSelectedTaluka('')
  }

  const downloadQRCode = () => {
    const link = document.createElement('a')
    link.href = qrcode
    link.download = (
      <img
        src={qrcode}
        className="w-80 text-center px-md-3 px-1 mb-3 mb-md-0"
        height={250}
      />
    )
    link.click()
  }

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value)
    setSelectedTaluka('')
  }

  const handleTalukaChange = (e) => {
    setSelectedTaluka(e.target.value)
  }
  const handleFileChange = (e, setter) => {
    setter(e.target.files[0])
  }
  const validateInputs = () => {
    const newErrors = {}

    if (!PCollageName.trim()) {
      newErrors.PCollageName = 'Last year school/college name is necessary'
    }

    if (!StdDiv.trim()) {
      newErrors.StdDiv = 'Standard and Division is necessary'
    }

    if (!CCollageName.trim()) {
      newErrors.CCollageName = 'Current School/College Name is necessary'
    }

    if (!CurrentStd.trim()) {
      newErrors.CurrentStd = 'Standard and Division is necessary'
    }

    if (!Profeciency) {
      newErrors.Profeciency = 'Please select this option'
    }

    if (!Fellowship) {
      newErrors.Fellowship = 'Please select this option'
    }

    setErrors(newErrors)

    // ✅ Return true if no errors
    return Object.keys(newErrors).length === 0
  }

  useEffect(() => {
    fetchSubCategories()
  }, []) // Fetch subcategories when the component mounts

  // Define the function to fetch subcategories
  function fetchSubCategories() {
    fetch(SubCateroryFindAllApi)
      .then((response) => response.json())
      .then((data) => {
        setSubCategories(data)
      })
      .catch((error) => {
        // console.error("Error fetching subcategories:", error);
        setError(true)
      })
  }

  let pdfToastId = null
  // Utility function to wait
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

  // const onClickGeneratePDF = async () => {
  //   try {
  //     setLoading(true);

  //     // Step 1️⃣ Submit form and get regId
  //     // console.log("➡️ Submitting form...");
  //     const regId = await handleSubmit();
  //     if (!regId) throw new Error("Registration failed! Please try again.");
  //     // toast.success("✅ Registration successful, regId:", regId);

  //     // Step 2️⃣ Upload documents
  //     // toast.warn("➡️ Uploading documents...");
  //     await handleSubmitUpload(regId);
  //     // toast.success("✅ Documents uploaded successfully");

  //     // Step 3️⃣ Generate PDF
  //     // toast.warn("➡️ Generating PDF...");
  //     await generatePDF(regId);
  //     // toast.success("✅ PDF generated successfully");

  //     // ✅ All done
  //     toast.success("All steps completed successfully!");
  //     setLoading(false);

  //   } catch (err) {
  //     console.error("❌ Error in onClickGeneratePDF:", err);
  //     toast.error(err.message || "Error generating PDF");
  //     setLoading(false);
  //   }
  // };

  // new changes
  // const generatePDF = async () => {
  //   try {
  //     const response = await axios.get(GeneratePDFApi, {
  //       responseType: 'blob',
  //     })

  //     const file = new Blob([response.data], {
  //       type: 'application/pdf',
  //     })

  //     const fileURL = window.URL.createObjectURL(file)

  //     window.open(fileURL)

  //     // OR download
  //     // const link = document.createElement("a");
  //     // link.href = fileURL;
  //     // link.download = "RegistrationForm.pdf";
  //     // link.click();
  //   } catch (error) {
  //     console.log(error)
  //     throw new Error('Error generating PDF')
  //   }
  // }

  const onClickGeneratePDF = async () => {
    try {
      setLoading(true)

      // Submit registration + documents
      const regId = await handleSubmit()
      if (!regId) throw new Error('Registration failed! Please try again.')

      // Generate PDF
      await generatePDF(regId)

      toast.success('Registration completed successfully!')
    } catch (err) {
      console.error(err)
      toast.error(err.message || 'Something went wrong')
    } finally {
      setLoading(false)
    }
  }

  //old code==============
  // const handleSubmit = async () => {
  //   const Obj = {
  //     s_fname: Sfname,
  //     s_mname: Smname,
  //     s_lname: Slname,
  //     father_fname: Smname,
  //     father_mname: Fmname,
  //     father_lname: Slname,
  //     village: Village,
  //     pincode: Pin,
  //     address: House,
  //     state: selectedState,
  //     district: selectedDistrict,
  //     taluka: selectedTaluka,
  //     adharNo: adharNo,
  //     mobile_no: Smobile,
  //     parents_mobno: Pmobile,
  //     sub_category: selectedSubCategory,
  //     dateofbirth: formattedDate,
  //     age: age,
  //     father_occupation: FOccupation,
  //     email: email,
  //     blood_group: bloodGroup,
  //     nextyearcollagename: CurrentStd,
  //     l_collagename: PCollageName,
  //     std: StdDiv,
  //     collage_name: CCollageName,
  //     profeciency: Profeciency,
  //     fellowship: Fellowship,
  //     medicalIssueFlag: parseInt(MedicalIssue),
  //     medicalIssueDescription: MedicalIssue === '1' ? MedicalIssueDescription : '',
  //     disabilityFlag: parseInt(Disability),
  //     disabilityDescription: Disability === '1' ? DisabilityDescription : '',
  //   };

  //   try {
  //     const response = await axios.post(RegristrationAddApi, Obj);

  //         if (response.data === 'ALREADYEXIST') {
  //         alert('Email already registered! Please try with a different email.');
  //         navigate('/StudentLogin');
  //         return null;
  //       } else if (response.data.message === 'SAVED' && response.data.regId) {
  //       sessionStorage.setItem('registrationId', response.data.regId);
  //       return response.data.regId; // ✅ Return regId to chain calls
  //     } else {
  //       throw new Error("Unexpected server response");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     throw new Error("Error submitting form");
  //   }
  // };

  const handleSubmit = async () => {
    try {
      const formData = new FormData()

      //============ Student Details ============

      //       s_fname:Soheb1
      // s_mname:D
      // s_lname:Mulani
      // father_fname:Dastgir
      // father_mname:Yasin
      // father_lname:Mulani
      // address:Sangli
      // village:Miraj
      // pincode:416410
      // state:1
      // district:1
      // taluka:1
      // father_occupation:Business
      // std:FYBCA
      // collage_name:ABC College
      // nextyearcollagename:XYZ College
      // sub_category:1
      // dateofbirth:15/08/2005
      // age:20
      // profeciency:0
      // fellowship:0
      // mob_no:9876543210
      // parents_mobno:9876543211
      // l_collagename:ABC College
      // email:test@gmail.com
      // adharNo:123456789012
      // medicalIssue_flag:1
      // medicalIssue_description:asd
      // disability_flag:0
      // disability_description:asd
      // blood_group:A +ve
      // pay_amount:50
      // tax_id:TXN123456
      // pay_mode:1
      // year:2026

      // photo
      // adharcard
      // marklist
      // profeciency_document
      // father_photo
      // tax_image,
      // year

      formData.append('s_fname', Sfname)
      formData.append('s_mname', Smname)
      formData.append('s_lname', Slname)

      formData.append('father_fname', Smname)
      formData.append('father_mname', Fmname)
      formData.append('father_lname', Slname)

      formData.append('address', House)
      formData.append('village', Village)
      formData.append('pincode', Pin)

      formData.append('state', selectedState)
      formData.append('district', selectedDistrict)
      formData.append('taluka', selectedTaluka)

      formData.append('father_occupation', FOccupation)

      formData.append('std', StdDiv)
      formData.append('collage_name', CCollageName)
      formData.append('nextyearcollagename', CurrentStd)

      formData.append('sub_category', selectedSubCategory)

      formData.append('dateofbirth', formattedDate)
      formData.append('age', age)

      formData.append('profeciency', Profeciency)
      formData.append('fellowship', Fellowship)

      formData.append('mob_no', Smobile)
      formData.append('parents_mobno', Pmobile)

      formData.append('l_collagename', PCollageName)
      formData.append('email', email)

      formData.append('adharNo', adharNo)

      formData.append('medicalIssue_flag', MedicalIssue)
      formData.append(
        'medicalIssue_description',
        MedicalIssue === '1' ? MedicalIssueDescription : '',
      )

      formData.append('disability_flag', Disability)
      formData.append(
        'disability_description',
        Disability === '1' ? DisabilityDescription : '',
      )

      formData.append('blood_group', bloodGroup)

      //============ Payment ============

      // formData.append('pay_amount', '50')
      formData.append('tax_id', taxId) // Your transaction id
      formData.append('pay_mode', paymentMode) // Example: 1

      //============ Documents ============

      //  formData.append('files', tax)
      // formData.append('files', photo)
      // formData.append('files', adharCard)
      // formData.append('files', markList)
      // formData.append('files', proficiencyDoc)
      // formData.append('files', parentPhoto)

      if (photo) {
        formData.append('photo', photo)
      }

      if (adharCard) {
        formData.append('adharcard', adharCard)
      }

      if (markList) {
        formData.append('marklist', markList)
      }

      if (proficiencyDoc) {
        formData.append('profeciency_document', proficiencyDoc)
      }

      if (parentPhoto) {
        formData.append('father_photo', parentPhoto)
      }

      if (tax) {
        formData.append('tax_image', tax)
      }

      const response = await axios.post(`${RegistrationAddNewApi}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      if (response.data === 'ALREADYEXIST') {
        alert('Email already registered! Please try with a different email.')
        navigate('/StudentLogin')
        return null
      } else if (response.data.message === 'SAVED' && response.data.reg_id) {
        sessionStorage.setItem('registrationId', response.data.reg_id)
        return response.data.reg_id // ✅ Return regId to chain calls
      } else {
        throw new Error('Unexpected server response')
      }
      throw new Error('Registration failed')
    } catch (error) {
      console.error(error)
      throw new Error('Error submitting registration')
    }
  }

  const handleSubmitUpload = async (RegistrationId) => {
    try {
      if (!RegistrationId) throw new Error('Registration ID missing')
      if (!taxId) throw new Error('Transaction ID is required')
      if (!paymentMode) throw new Error('Pay Mode is required')
      if (!tax) throw new Error('Screenshot is required')

      const formData = new FormData()
      formData.append('files', tax)
      formData.append('files', photo)
      formData.append('files', adharCard)
      formData.append('files', markList)
      formData.append('files', proficiencyDoc)
      formData.append('files', parentPhoto)
      formData.append('taxId', taxId)
      formData.append('pay_mode', paymentMode)
      formData.append('reg_id', RegistrationId)

      const res = await axios.post(
        `${DocumentAddApi}/${RegistrationId}`,
        formData,
      )

      // ✅ Handle non-success responses if backend sends custom flags

      if (res.data?.regId == null) {
        toast.error('Upload failed, Reg Id not found!!')
        return false
      }
      if (res.data?.message !== 'SAVED') {
        toast.error('Upload failed')
        return false
      }

      toast.success('Documents uploaded successfully!')
      return true
    } catch (err) {
      console.error('❌ Upload error:', err)

      if (err.response) {
        // Server responded with a status outside 2xx
        toast.error(
          err.response.data?.message ||
            `Server Error: ${err.response.status} ${err.response.statusText}`,
        )
      } else if (err.request) {
        // Request made but no response
        toast.error('No response from server. Please try again later.')
      } else {
        // Something else (validation or JS error)
        toast.error(err.message || 'Unexpected error occurred')
      }

      return false
    }
  }

  const generatePDF = async (regId) => {
    pdfToastId = toast.info('Please wait, generating PDF...', {
      autoClose: false,
      toastId: 'pdf-wait',
    })

    try {
      // Convert your logos + static placeholders
      const [
        logoBase64,
        logo2Base64,
        studentStaticBase64,
        parentStaticBase64,
      ] = await Promise.all([
        toDataURL(logo),
        toDataURL(logo2),
        toDataURL(studentPhoto), // 🔥 your static student img
        toDataURL(parentsPhoto), // 🔥 your static parent img
      ])

      const res = await axios.get(`${DocumentFindOneApi}/${regId}`)
      const data = res.data
      if (!data) throw new Error('No data found for PDF')

      toast.dismiss('pdf-wait')

      const documentDefinition = {
        content: [
          {
            columns: [
              { style: 'logo', width: '15%', image: logoBase64, fit: [50, 50] },
              {
                width: '70%',
                text: [
                  { text: "Dakshin Bharat Jain Sabha's \n", style: 'header1' },
                  {
                    text: 'Sheth R D Dawada Digambar Jain Boarding,\n',
                    style: 'header',
                  },
                  {
                    text:
                      '37, Mahavir Nagar, Sangli 416416, Phone: 0233-262306\n',
                    style: 'header2',
                  },
                  {
                    text:
                      'Web : www.jainboardingsangli.com    Email : jainboardingsangli@gmail.com \n',
                    style: 'header3',
                  },
                ],
              },
              {
                style: 'logo',
                width: '15%',
                image: logo2Base64,
                fit: [50, 50],
              },
            ],
          },
          {
            margin: [0, 15, 0, 0],
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 1,
              },
            ],
          },
          {
            text: `Form Date : ${data.currDate}`,
            style: 'formDate',
            alignment: 'right',
          },
          {
            text: 'Admission Application',
            style: 'title',
            alignment: 'center',
            margin: [0, 8, 0, 0],
          },
          {
            text: `Form No. : ${data.reg_id}`,
            style: 'formNo',
            alignment: 'left',
            margin: [0, -15, 0, 0],
          },
          {
            text: "Hon'ble Secretary/Superintendent",
            style: 'subheader',
            margin: [0, 15, 0, 0],
          },
          {
            text: `Sheth R D Dawada Digambar Jain Boarding, Sangli
        I, the undersigned, request you to grant me admission in 'Sangli Jain Boarding'.
        I have read the Boarding & Mess rules, agree to them and will strictly follow them .`,
            style: 'text',
          },
          {
            columns: [
              {
                width: '*',
                text: '',
              },
              {
                width: 'auto',
                stack: [
                  {
                    text: '',
                    style: 'photo',
                    alignment: 'center',
                    margin: [0, -10, 0, 0],
                  },
                  {
                    image: studentStaticBase64,
                    width: 80,
                    height: 85,
                    border: [true, true, true, true],
                    borderColor: 'gray',
                    border: '2px solid',
                    margin: [0, -60, 0, 0],
                  },
                ],
              },
            ],
          },
          {
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: 'Personal Information',
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                ],
                [
                  {
                    stack: [
                      {
                        text: [
                          {
                            text: "Student's Full Name: ",
                            bold: true,
                            style: 'text',
                          },
                          { text: `${data.name}\n`, style: 'text' },
                          {
                            text: "Father's Full Name: ",
                            bold: true,
                            style: 'text',
                          },
                          { text: `${data.fatherName}\n`, style: 'text' },
                          { text: 'Address: ', bold: true, style: 'text' },
                          { text: `${data.address}\n`, style: 'text' },
                          {
                            text: 'Have you any major medical issues ?: ',
                            bold: true,
                            style: 'text',
                          },
                          {
                            text: `${data.medicalIssue_flag}\n`,
                            style: 'text',
                          },
                          {
                            text: 'Description :  ',
                            bold: true,
                            style: 'text',
                          },
                          {
                            text: `${data.medicalIssue_description}\n`,
                            style: 'text',
                          },
                          {
                            text: 'Have you any disability ?: ',
                            bold: true,
                            style: 'text',
                          },
                          { text: `${data.disability_flag} \n`, style: 'text' },
                          {
                            text: 'Description :  ',
                            bold: true,
                            style: 'text',
                          },
                          {
                            text: `${data.disability_description}\n`,
                            style: 'text',
                          },
                        ],
                        lineHeight: 1.3,
                      },
                      {
                        columns: [
                          {
                            width: '50%',
                            stack: [
                              {
                                text: [
                                  {
                                    text: 'Adhar No.: ',
                                    bold: true,
                                    style: 'text',
                                  },
                                  { text: `${data.adharNo}\n`, style: 'text' },
                                  {
                                    text: 'Contact No.: ',
                                    bold: true,
                                    style: 'text',
                                  },
                                  { text: `${data.mob_no}\n`, style: 'text' },
                                  {
                                    text: "Parent's Contact No.: ",
                                    bold: true,
                                    style: 'text',
                                  },
                                  {
                                    text: `${data.parents_mobno}\n`,
                                    style: 'text',
                                  },
                                  {
                                    text: 'Birthdate: ',
                                    bold: true,
                                    style: 'text',
                                  },
                                  {
                                    text: `${data.dateofbirth}\n`,
                                    style: 'text',
                                  },
                                  {
                                    text: 'Blood Group: ',
                                    bold: true,
                                    style: 'text',
                                  },
                                  {
                                    text: `${data.blood_group}\n`,
                                    style: 'text',
                                  },
                                ],
                                lineHeight: 1.3,
                              },
                            ],
                          },
                          {
                            width: '50%',
                            stack: [
                              {
                                text: [
                                  { text: 'Age: ', bold: true, style: 'text' },
                                  {
                                    text: `${data.age} ${
                                      data.age ? 'Yrs' : ''
                                    }\n`,
                                    style: 'text',
                                  },
                                  {
                                    text: "Student's Sub-Cast: ",
                                    bold: true,
                                    style: 'text',
                                  },
                                  {
                                    text: `${data.sub_category}\n`,
                                    style: 'text',
                                  },
                                  {
                                    text: "Father's Occupation: ",
                                    bold: true,
                                    style: 'text',
                                  },
                                  {
                                    text: `${data.father_occupation}\n`,
                                    style: 'text',
                                  },
                                  {
                                    text: 'Email Id: ',
                                    bold: true,
                                    style: 'text',
                                  },
                                  { text: `${data.email}\n`, style: 'text' },
                                ],
                                lineHeight: 1.4,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                    margin: [0, 7, 0, 0],
                  },
                ],
              ],
            },
            layout: 'noBorders',
            margin: [0, 8, 0, 0],
          },
          {
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: 'Educational Information',
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                ],
                [
                  {
                    text: [
                      {
                        text: 'Last year School/college Name: ',
                        bold: true,
                        style: 'text',
                      },
                      { text: `${data.l_collagename}\n`, style: 'text' },
                      {
                        text: 'Standard and Division: ',
                        bold: true,
                        style: 'text',
                      },
                      { text: `${data.std}\n`, style: 'text' },
                      {
                        text: 'Current School/College Name: ',
                        bold: true,
                        style: 'text',
                      },
                      { text: `${data.collage_name}\n`, style: 'text' },
                      {
                        text: 'Current Standard and Division: ',
                        bold: true,
                        style: 'text',
                      },
                      { text: `${data.nextyearcollagename}\n`, style: 'text' },
                      {
                        text:
                          'Did you stay in Sangli Jain Boarding last year?: ',
                        bold: true,
                        style: 'text',
                      },
                      { text: `${data.profeciency}\n`, style: 'text' },
                      {
                        text:
                          "Have you received a Dakshin Bharat Jain Sabha's Scholarship ?: ",
                        bold: true,
                        style: 'text',
                      },
                      { text: `${data.fellowship}\n`, style: 'text' },
                    ],
                    margin: [0, 7, 0, 0],
                    lineHeight: 1.4,
                  },
                ],
              ],
            },
            layout: 'noBorders',
            margin: [0, 8, 0, 0],
          },

          // Full-width table header
          {
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: 'Document Uploaded',
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                ],
              ],
            },
            layout: 'noBorders',
            margin: [0, 8, 0, 0],
          },

          // Two-column layout: document info + father's image
          {
            columns: [
              {
                width: '80%',
                text: [
                  { text: "Student's Aadhar Card: ", bold: true },
                  { text: 'Yes\n' },
                  {
                    text: "Student's School Leaving Certificate: ",
                    bold: true,
                  },
                  { text: 'Yes\n' },
                  {
                    text: 'Current Year School Admission Receipt: ',
                    bold: true,
                  },
                  { text: 'Yes\n' },
                ],
                margin: [0, 7, 0, 0],
                lineHeight: 1.3,
                style: 'text',
              },
              {
                width: '20%',
                stack: [
                  {
                    text: "Parent's Photo",
                    style: 'photo',
                    alignment: 'center',
                    margin: [0, 0, -10, 5],
                  },
                  {
                    image: parentStaticBase64, // Replace with actual base64 image
                    width: 80,
                    height: 85,
                    alignment: 'center',
                    margin: [0, 5, -10, 0],
                  },
                ],
              },
            ],
            margin: [0, 0, 0, 10],
          },
          { text: 'Date:', margin: [0, 20, 0, 0] },
          {
            text: "Student's signature",
            alignment: 'center',
            margin: [0, -14, 0, 0],
          },
          {
            text: "Parent's signature",
            alignment: 'right',
            margin: [0, -14, 0, 0],
          },
        ],
        styles: {
          header: {
            fontSize: 15,
            alignment: 'center',
            bold: true,
          },
          formDate: {
            fontSize: 11,
            bold: true,
          },
          text: {
            fontSize: 10,
          },
          formNo: {
            fontSize: 10,
            bold: true,
          },
          header1: {
            fontSize: 12,
            alignment: 'center',
          },
          header2: {
            fontSize: 11,
            alignment: 'center',
          },
          header3: {
            fontSize: 9,
            alignment: 'center',
          },
          logo: {
            alignment: 'center',
          },
          photo: {
            border: '1px solid black',
            height: 100,
            width: 100,
          },
          subheader: { fontSize: 12, bold: true },
          title: { fontSize: 14, bold: true },
          tableHeader: {
            fontSize: 12,
            bold: true,
            fillColor: '#a2d6f8',
            color: 'black',
          },
        },
      }

      pdfMake.createPdf(documentDefinition).open()
      //   pdfMake.createPdf(documentDefinition).getBlob((blob) => {
      //   const url = URL.createObjectURL(blob);
      //   window.location.href = url; // 🔥 replaces current tab
      // });

      toast.dismiss(pdfToastId)
      toast.success('PDF generated successfully!')
      navigate('/')
    } catch (err) {
      toast.dismiss('pdf-wait')
      throw err
    }
  }

  const [currentPage, setCurrentPage] = useState(1)
  const totalSteps = 6 // Total number of steps

  // Function to handle navigation to the next page
  const goToNextPage = () => {
    if (currentPage < totalSteps) {
      setCurrentPage(currentPage + 1)
    }
  }

  // Function to handle navigation to the previous page
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  // Function to update the progress bar
  function updateProgressBar() {
    const percentComplete = ((currentPage - 1) / (totalSteps - 1)) * 100
    $('.progress-bar')
      .css('width', percentComplete + '%')
      .css('font-size', '0')
      .css('background-color', '#4CAF50')
      .attr('aria-valuenow', percentComplete)
      .text(percentComplete.toFixed(0) + '%')
  }

  // useEffect hook to update progress bar whenever currentPage changes
  useEffect(() => {
    updateProgressBar()
  }, [currentPage])

  const [isChecked, setIsChecked] = useState(false) // State variable for checkbox
  const [isValid, setIsValid] = useState(false) // State variable for validation status

  // Handler for checkbox change
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked) // Toggle checkbox state
    setIsValid(false) // Reset validation status when checkbox changes
  }

  // Handler for next button click
  const handleNextButtonClick = () => {
    if (!isValid) {
      toast.error('Please select the checkbox to proceed.')
    } else {
      goToNextPage()
    }
  }

  // Function to simulate going to the next page

  // Validation function
  const validate = () => {
    // Add your validation logic here
    // For example, checking if the checkbox is checked
    setIsValid(isChecked)
  }

  // Call the validation function whenever the checkbox state changes
  // This will update the validation status accordingly
  useEffect(() => {
    validate()
  }, [isChecked])

  const validateForm1 = () => {
    let formIsValid = true
    let newErrors = {}

    if (!Sfname.trim()) {
      formIsValid = false
      newErrors['Sfname'] = 'First name is necessary'
    }
    if (!Smname.trim()) {
      formIsValid = false
      newErrors['Smname'] = 'Middle name is necessary.'
    }
    if (!Slname.trim()) {
      formIsValid = false
      newErrors['Slname'] = 'Last Name is necessary.'
    }

    // Validation for father's middle name
    if (!Fmname.trim()) {
      formIsValid = false
      newErrors['Fmname'] = 'Middle name is necessary.'
    }

    //Validation for selected state
    if (!selectedState) {
      formIsValid = false
      newErrors['selectedState'] = 'State Select'
    }
    // Validation for selected district
    if (!selectedDistrict) {
      formIsValid = false
      newErrors['selectedDistrict'] = 'District Select'
    }

    // Validation for selected taluka
    if (!selectedTaluka) {
      formIsValid = false
      newErrors['selectedTaluka'] = 'Taluka Select'
    }

    if (!selectedSubCategory) {
      formIsValid = false
      newErrors['selectedSubCategory'] = 'Sub Category'
    }

    // Validation for village
    if (!Village.trim()) {
      formIsValid = false
      newErrors['Village'] = 'Village name is necessary.'
    }

    // Validation for house
    if (!House.trim()) {
      formIsValid = false
      newErrors['House'] = 'House number/colony is necessary.'
    }

    // Validation for pin
    if (!Pin.trim()) {
      formIsValid = false
      newErrors['Pin'] = 'Pincode is necessary.'
    }

    // Validation for adhar number
    if (!adharNo.trim()) {
      formIsValid = false
      newErrors['adharNo'] = 'Adhar number is necessary.'
    }

    // Validation for mobile number
    if (!Smobile.trim()) {
      formIsValid = false
      newErrors['Smobile'] = 'Contact number is necessary.'
    }

    // Validation for parent's mobile number
    if (!Pmobile.trim()) {
      formIsValid = false
      newErrors['Pmobile'] = 'Contact number is necessary.'
    }

    // Validation for date of birth
    if (!date) {
      formIsValid = false
      newErrors['date'] = 'BirthDate is necessary.'
    }

    // Validation for age

    // Validation for father's occupation
    if (!FOccupation.trim()) {
      formIsValid = false
      newErrors['FOccupation'] = 'Parents Occupation is necessary.'
    }
    if (!email.trim()) {
      formIsValid = false
      newErrors['email'] = 'Email Id is necessary.'
    }
    if (!bloodGroup) {
      formIsValid = false
      newErrors['bloodGroup'] = 'Blood Group is necessary.'
    }

    if (!MedicalIssue) {
      formIsValid = false
      newErrors['MedicalIssue'] = 'Medical Issue is necessary'
    }
    if (!Disability) {
      formIsValid = false
      newErrors['Disability'] = 'Disability is necessary'
    }

    // // Validation for subcategory
    // if (!SubCategory.trim()) {
    //   formIsValid = false;
    //   newErrors["SubCategory"] = "Student Sub-Category is necessary";
    // }

    setErrors(newErrors)
    return formIsValid
  }

  const handleNextClick = () => {
    if (validateForm1()) {
      console.log('✅ Form step 1 valid, moving to next step')
      goToNextPage() // Navigate to the next page only if form validation passes
    } else {
      console.log('❌ Validation failed')
    }
  }

  const handleNextClick1 = () => {
    const isValid = validateInputs()
    if (isValid) {
      // go to the next step
      console.log('✅ Form step 2 valid, moving to next step')
      goToNextPage() // <-- replace with your actual navigation logic
    } else {
      console.log('❌ Validation failed')
    }
  }

  const calculateAge = (birthdate) => {
    if (!birthdate) return

    const today = new Date()
    let age = today.getFullYear() - birthdate.year()
    const m = today.getMonth() - birthdate.month()
    if (m < 0 || (m === 0 && today.getDate() < birthdate.date())) {
      age -= 1
    }
    return age
  }

  const handleDateChange = (selectedDate) => {
    if (!selectedDate) {
      setDate(null)
      setAge('')
      return
    }

    const newAge = calculateAge(selectedDate)
    if (newAge < 12) {
      setErrors({ ...errors, date: 'Age must be at least 12 years.' })
      setDate(null)
      setAge('')
    } else {
      setErrors({ ...errors, date: null })
      setDate(selectedDate)
      setAge(newAge)
    }
  }

  useEffect(() => {
    if (date) {
      setAge(calculateAge(date))
    }
  }, [date])

  const handleAdharCardChange = (e) => {
    const file = e.target.files[0]
    // Additional validation can be added here
    setAdharCard(file)
  }

  const handlePhotoChange = (e) => {
    const file = e.target.files[0]
    // Additional validation can be added here
    setPhoto(file)
  }

  const handleMarkListChange = (e) => {
    const file = e.target.files[0]
    // Additional validation can be added here
    setMarkList(file)
  }

  const handleProficiencyDocChange = (e) => {
    const file = e.target.files[0]
    // Additional validation can be added here
    setProficiencyDoc(file)
  }

  const handleParentPhotoChange = (e) => {
    const file = e.target.files[0]
    // Additional validation can be added here
    setParentPhoto(file)
  }

  const validateFormup = () => {
    return adharCard && photo && markList && proficiencyDoc && parentPhoto
  }

  // Function to handle upload event
  const handleup = () => {
    const isValid = validateFormup()
    if (isValid) {
      // Proceed to the next page
      goToNextPage()
    }
  }

  function toggleSubmitButton() {
    const checkbox = document.getElementById('agreeCheckbox')
    const submitButton = document.querySelector('.nextBtn')

    // Enable/disable the submit button based on checkbox state
    submitButton.disabled = !checkbox.checked
  }
  const input = {
    // border: '1px solid',
    // height: '35px',
    // color: 'black',
  }

  const handleBlur = () => {
    if (adharNo.length < 12) {
      setWarning('Aadhar number must be exactly 12 digits.')
    } else {
      setWarning('')
    }
  }

  const handleBlur1 = () => {
    if (Smobile.length < 10) {
      setWarning1('Phone No. must be exactly 10 digits.')
    } else {
      setWarning1('')
    }
  }

  const handleBlur2 = () => {
    if (Pmobile.length < 10) {
      setWarning2('Phone No. must be exactly 10 digits.')
    } else {
      setWarning2('')
    }
  }

  return (
    <>
      <ToastContainer />
      {/* <SideNavbarStudentReg /> */}
      <section className="home-section">
        <NavBarStudentReg />

        <div className="py-2 py-md-5 px-md-5">
          <div className="row p-0 m-0 px-md-5 pb-5">
            <div className="col-12 col-lg-1"></div>
            <div className="col-12 col-lg-10">
              <form>
                {/* =============Rules Step============= */}
                {currentPage === 1 && (
                  <div
                    className="my-3 px-md-4 px-3 mx-md-4 mx-2 py-4"
                    style={{
                      textAlign: 'left',
                      borderRadius: '15px',
                      backgroundColor: '#fff',
                    }}
                    id="step-1"
                  >
                    <h3 style={{ color: 'black' }}>Rules</h3>
                    <div>
                      <div style={{ lineHeight: '40px' }}>
                        <div>
                          <ul>
                            {rules.map((rule) => (
                              <li key={rule.id}>
                                {rule.serial_no}. &nbsp; {rule.description}
                                <br />
                              </li>
                            ))}
                          </ul>
                        </div>

                        {/* Next button */}
                        <Row>
                          <Col sm={1} md={1}>
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                            />
                          </Col>
                          <Col sm={11} md={11}></Col>
                        </Row>
                        <label style={{ color: 'black', marginLeft: '10px' }}>
                          {' '}
                          वरील सर्व नियम व अटी मान्य आहेत
                        </label>
                        <div className="button-container  text-center">
                          <button
                            type="button"
                            className={`text-center fs-4 btn3 btn-primary nextBtn ${
                              !isValid && 'disabled'
                            }`}
                            style={{
                              backgroundColor: '#0783d6',
                              color: 'black',
                              width: '100px',
                              border: '0px',
                              marginTop: '-10px',
                            }}
                            onClick={handleNextButtonClick}
                          >
                            Next
                          </button>
                        </div>

                        <br />
                      </div>
                    </div>
                  </div>
                )}

                {/* =============First Form Step============= */}
                {currentPage === 2 && (
                  <>
                    <div id="step-2">
                      <div
                        className="px-md-5 px-2 my-4 shadow py-4"
                        style={{
                          backgroundColor: 'white',
                          borderRadius: '10px',
                        }}
                      >
                        <div className="row m-0">
                          <h2
                            className="room-change-title text-start mt-md-4 mt-2"
                            style={{ color: '#0783d6' }}
                          >
                            Personal Information
                          </h2>
                        </div>

                        <Row>
                          <label className="mt-3 labelText">
                            Student's Full Name
                          </label>
                          <Col sm={12} md={4} className="mt-md-2 mt-3">
                            <input
                              maxLength={100}
                              type="text"
                              required
                              size="sm"
                              id="name"
                              value={Sfname}
                              name="s_fname"
                              onChange={(e) => setSfname(e.target.value)}
                              placeholder="First Name"
                              className={`form-control ${
                                errors.Sfname ? 'error-input' : ''
                              }`}
                            />
                            {errors.Sfname && (
                              <div className="error-message">
                                {errors.Sfname}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-2 mt-3">
                            <input
                              maxLength={100}
                              type="text"
                              required="required"
                              className={`form-control ${
                                errors.Smname ? 'error-input' : ''
                              }`}
                              id="name"
                              value={Smname}
                              name="s_mname"
                              onChange={(e) => setSmname(e.target.value)}
                              placeholder="Middle Name"
                            />
                            {errors.Smname && (
                              <div className="error-message">
                                {errors.Smname}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-2 mt-3">
                            <input
                              maxLength={100}
                              type="text"
                              required="required"
                              className={`form-control ${
                                errors.Slname ? 'error-input' : ''
                              }`}
                              id="name"
                              value={Slname}
                              name="s_lname"
                              onChange={(e) => setSlname(e.target.value)}
                              placeholder="Last Name"
                            />
                            {errors.Slname && (
                              <div className="error-message">
                                {errors.Slname}
                              </div>
                            )}
                          </Col>
                        </Row>

                        <Row>
                          <label className="mt-3 labelText">
                            {' '}
                            Father's Full Name
                          </label>
                          <Col sm={12} md={4} className="mt-md-2 mt-3">
                            <input
                              maxLength={100}
                              type="text"
                              required="required"
                              className={`form-control form-control-sm ${
                                errors.Smname ? 'error-input' : ''
                              }`}
                              id="name"
                              value={Smname}
                              name="father_fname"
                              placeholder="First Name"
                            />{' '}
                            {errors.Smname && (
                              <div className="error-message">
                                {errors.Smname}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-2 mt-3">
                            <FormControl
                              maxLength={100}
                              type="text"
                              required="required"
                              className={`form-control ${
                                errors.Fmname ? 'error-input' : ''
                              }`}
                              id="name"
                              value={Fmname}
                              name="father_mname"
                              onChange={(e) => setFmname(e.target.value)}
                              placeholder="Middle Name"
                            />{' '}
                            {errors.Fmname && (
                              <div className="error-message">
                                {errors.Fmname}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-2 mt-3">
                            <input
                              maxLength={100}
                              type="text"
                              className={`form-control ${
                                errors.Slname ? 'error-input' : ''
                              }`}
                              id="name"
                              value={Slname}
                              name="father_lname"
                              placeholder="Last Name"
                            />
                            {errors.Slname && (
                              <div className="error-message">
                                {errors.Slname}
                              </div>
                            )}
                          </Col>
                        </Row>

                        <Row>
                          <label className="mt-3 labelText">Address</label>
                          <Col sm={12} md={4} className="mt-md-2 mt-3">
                            <select
                              required
                              className={`form-select ${
                                errors.selectedState ? 'error-input' : ''
                              }`}
                              id="state"
                              value={selectedState}
                              name="state"
                              onChange={handleStateChange}
                            >
                              <option value="">State</option>
                              {stateList.map((state) => (
                                <option key={state.id} value={state.id}>
                                  {state.state_name}
                                </option>
                              ))}
                            </select>
                            {errors.selectedState && (
                              <div className="error-message">
                                {errors.selectedState}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-2 mt-3">
                            <select
                              required
                              className={`form-select ${
                                errors.selectedDistrict ? 'error-input' : ''
                              }`}
                              id="district"
                              value={selectedDistrict}
                              name="district"
                              onChange={handleDistrictChange}
                            >
                              <option value="">District</option>
                              {districtList.map((district) => (
                                <option key={district.id} value={district.id}>
                                  {district.districtenname}
                                </option>
                              ))}
                            </select>
                            {errors.selectedDistrict && (
                              <div className="error-message">
                                {errors.selectedDistrict}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-2 mt-3">
                            <select
                              required
                              className={`form-select ${
                                errors.selectedTaluka ? 'error-input' : ''
                              }`}
                              id="taluka"
                              value={selectedTaluka}
                              name="taluka"
                              onChange={handleTalukaChange}
                            >
                              <option value="">Taluka</option>
                              {talukaList.map((taluka) => (
                                <option key={taluka.id} value={taluka.id}>
                                  {taluka.talukaenname}
                                </option>
                              ))}
                            </select>{' '}
                            {errors.selectedTaluka && (
                              <div className="error-message">
                                {errors.selectedTaluka}
                              </div>
                            )}
                          </Col>
                        </Row>

                        <Row>
                          <Col sm={12} md={4} className="mt-md-4 mt-3">
                            <input
                              maxLength={100}
                              type="text"
                              required="required"
                              className={`form-control ${
                                errors.Village ? 'error-input' : ''
                              }`}
                              id="name"
                              value={Village}
                              name="village"
                              onChange={(e) => setVillage(e.target.value)}
                              placeholder="Village/City"
                            />{' '}
                            {errors.Village && (
                              <div className="error-message">
                                {errors.Village}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-4 mt-3">
                            <input
                              maxLength={100}
                              type="text"
                              required="required"
                              className={`form-control ${
                                errors.House ? 'error-input' : ''
                              }`}
                              id="name"
                              value={House}
                              name="address"
                              onChange={(e) => setHouse(e.target.value)}
                              placeholder="House Name/No/Road/Chowk/Colony/Landmark"
                            />{' '}
                            {errors.House && (
                              <div className="error-message">
                                {errors.House}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-4 mt-3">
                            <input
                              maxLength={6}
                              type="text"
                              className={`form-control ${
                                errors.Pin ? 'error-input' : ''
                              }`}
                              id="name"
                              value={Pin}
                              name="pincode"
                              onChange={(e) => {
                                const input = e.target.value
                                if (/^\d*$/.test(input) && input.length <= 6) {
                                  setPin(input)
                                }
                              }}
                              placeholder="Pincode"
                            />
                            {errors.Pin && (
                              <div className="error-message">{errors.Pin}</div>
                            )}
                          </Col>
                        </Row>

                        <Row>
                          <Col sm={12} md={4} className="mt-md-2 mt-2">
                            <label className="mt-md-3 mt-1 labelText">
                              Student Adhar No.
                            </label>
                            <input
                              id="mobileNumber"
                              type="text"
                              required="required"
                              className={`form-control ${
                                errors.adharNo || warning ? 'error-input' : ''
                              }`}
                              value={adharNo}
                              name="adharNo"
                              onChange={(e) => setAdharNo(e.target.value)}
                              onKeyPress={(e) => {
                                const charCode = e.which ? e.which : e.keyCode
                                if (
                                  charCode > 31 &&
                                  (charCode < 48 || charCode > 57)
                                ) {
                                  e.preventDefault()
                                }
                              }}
                              onBlur={handleBlur}
                              maxLength={12}
                              placeholder=" Adhar Number"
                            />{' '}
                            {warning && (
                              <div
                                style={{
                                  color: 'red',
                                  marginTop: '4px',
                                  fontSize: '14px',
                                }}
                              >
                                {warning}
                              </div>
                            )}
                            {errors.adharNo && (
                              <div className="error-message">
                                {errors.adharNo}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-2 mt-2">
                            <label className="mt-md-3 mt-1 labelText">
                              Student Contact No.
                            </label>
                            <input
                              id="mobileNumber"
                              type="text"
                              required="required"
                              className={`form-control ${
                                errors.Smobile || warning1 ? 'error-input' : ''
                              }`}
                              value={Smobile}
                              name="mobile_no"
                              onChange={(e) => setSmobile(e.target.value)}
                              onKeyPress={(e) => {
                                const charCode = e.which ? e.which : e.keyCode
                                if (
                                  charCode > 31 &&
                                  (charCode < 48 || charCode > 57)
                                ) {
                                  e.preventDefault()
                                }
                              }}
                              onBlur={handleBlur1}
                              maxLength={10}
                              placeholder=" contact Number/Phone"
                            />{' '}
                            {warning1 && (
                              <div
                                style={{
                                  color: 'red',
                                  marginTop: '4px',
                                  fontSize: '14px',
                                }}
                              >
                                {warning1}
                              </div>
                            )}
                            {errors.Smobile && (
                              <div className="error-message">
                                {errors.Smobile}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-2 mt-2">
                            <label className="mt-md-3 mt-1 labelText">
                              Parent's Contact No.
                            </label>
                            <input
                              id="mobileNumber"
                              type="text"
                              required="required"
                              className={`form-control ${
                                errors.Pmobile || warning2 ? 'error-input' : ''
                              }`}
                              value={Pmobile}
                              name="parents_mobno"
                              onChange={(e) => setPmobile(e.target.value)}
                              onKeyPress={(e) => {
                                const charCode = e.which ? e.which : e.keyCode
                                if (
                                  charCode > 31 &&
                                  (charCode < 48 || charCode > 57)
                                ) {
                                  e.preventDefault()
                                }
                              }}
                              onBlur={handleBlur2}
                              maxLength={10}
                              placeholder=" parents contact Number/Phone"
                            />
                            {warning2 && (
                              <div
                                style={{
                                  color: 'red',
                                  marginTop: '4px',
                                  fontSize: '14px',
                                }}
                              >
                                {warning2}
                              </div>
                            )}
                            {errors.Pmobile && (
                              <div className="error-message">
                                {errors.Pmobile}
                              </div>
                            )}
                          </Col>
                        </Row>

                        <Row>
                          <Col sm={12} md={3} className="mt-md-2 mt-2">
                            <label className="mt-md-3 mt-1 labelText">
                              Blood Group
                            </label>
                            <select
                              className="form-select"
                              defaultValue="Choose..."
                              value={bloodGroup}
                              onChange={(e) => setBloodGroup(e.target.value)}
                              required
                            >
                              <option>Choose...</option>
                              <option value="A +ve">A +ve</option>
                              <option value="A -ve">A -ve</option>
                              <option value="B +ve">B +ve</option>
                              <option value="B -ve">B -ve</option>
                              <option value="AB +ve">AB +ve</option>
                              <option value="AB -ve">AB -ve</option>
                              <option value="O +ve">O +ve</option>
                              <option value="O -ve">O -ve</option>
                              <option value="Other">Other</option>
                            </select>
                            {errors.bloodGroup && (
                              <div className="error-message">
                                {errors.bloodGroup}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={3} className="mt-md-2 mt-2">
                            <label className="mt-md-3 mt-1 labelText">
                              Date Of Birth
                            </label>
                            <DatePicker
                              name="dateofbirth"
                              className={`form-control w-100 custom-datepicker ${
                                errors.date ? 'error-input' : ''
                              }`}
                              required
                              value={date}
                              onChange={handleDateChange}
                              format="DD/MM/YYYY"
                              placeholder="BirthDate"
                            />
                            {errors.date && (
                              <div className="error-message">{errors.date}</div>
                            )}
                          </Col>

                          <Col sm={12} md={2} className="mt-md-2 mt-2">
                            <label className="mt-md-3 mt-1 labelText">
                              Age
                            </label>
                            <input
                              type="number"
                              required
                              className={`form-control ${
                                errors.age ? 'error-input' : ''
                              }`}
                              name="age"
                              value={age}
                              readOnly
                              placeholder="Age"
                            />
                            {errors.age && (
                              <div className="error-message">{errors.age}</div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-2 mt-2">
                            <label className="mt-md-3 mt-1 labelText">
                              Email Id
                            </label>
                            <input
                              maxLength={200}
                              type="email"
                              required="required"
                              className={`form-control ${
                                errors.FOccupation ? 'error-input' : ''
                              }`}
                              name="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              placeholder="Email Id"
                            />{' '}
                            {errors.email && (
                              <div className="error-message">
                                {errors.email}
                              </div>
                            )}
                          </Col>
                        </Row>

                        <Row>
                          <Col sm={12} md={4} className="mt-md-2 mt-2">
                            <label className="mt-md-3 mt-1 labelText">
                              Student's Sub-Cast
                            </label>
                            <select
                              required
                              className={`form-select ${
                                error ? 'error-input' : ''
                              }`}
                              name="sub_category"
                              value={selectedSubCategory}
                              onChange={(e) =>
                                setSelectedSubCategory(e.target.value)
                              }
                            >
                              <option value="">Select</option>
                              {subCategories.map((subCategory) => (
                                <option
                                  key={subCategory.id}
                                  value={subCategory.id}
                                >
                                  {subCategory.categoryname}
                                </option>
                              ))}
                            </select>
                            {errors.selectedSubCategory && (
                              <div className="error-message">
                                {errors.selectedSubCategory}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-2 mt-2">
                            <label className="mt-md-3 mt-1 labelText">
                              Parent's Occupation
                            </label>
                            <input
                              maxLength={200}
                              type="text"
                              required="required"
                              className={`form-control ${
                                errors.FOccupation ? 'error-input' : ''
                              }`}
                              name="father_occupation"
                              value={FOccupation}
                              onChange={(e) => setFOccupation(e.target.value)}
                              placeholder="Parents Occupation"
                            />
                            {errors.FOccupation && (
                              <div className="error-message">
                                {errors.FOccupation}
                              </div>
                            )}
                          </Col>

                          <Col sm={12} md={4} className="mt-md-2 mt-2">
                            <label className="mt-md-3 mt-1 labelText">
                              Have you any major medical issues ?
                            </label>
                            <select
                              className={`form-select ${
                                error ? 'error-input' : ''
                              }`}
                              name="medicalIssue"
                              value={MedicalIssue}
                              onChange={(e) => setMedicalIssue(e.target.value)}
                              required="required"
                            >
                              <option value>Select</option>
                              <option value="1">Yes</option>
                              <option value="0">No</option>
                            </select>
                            {errors.MedicalIssue && (
                              <div className="error-message">
                                {errors.MedicalIssue}
                              </div>
                            )}
                          </Col>

                          {MedicalIssue === '1' && (
                            <Col sm={12} md={4} className="mt-md-2 mt-2">
                              <>
                                <label className="mt-md-3 mt-1 labelText">
                                  Describe Medical Issue
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Describe your medical issue"
                                  value={MedicalIssueDescription}
                                  onChange={(e) =>
                                    setMedicalIssueDescription(e.target.value)
                                  }
                                  required
                                />
                              </>
                            </Col>
                          )}

                          <Col sm={12} md={4} className="mt-md-2 mt-2">
                            <label className="mt-md-3 mt-1 labelText">
                              Have you any disability ?
                            </label>
                            <select
                              className="form-select"
                              name="disability"
                              value={Disability}
                              onChange={(e) => setDisability(e.target.value)}
                              required="required"
                            >
                              <option value>Select</option>
                              <option value="1">Yes</option>
                              <option value="0">No</option>
                            </select>
                            {errors.Disability && (
                              <div className="error-message">
                                {errors.Disability}
                              </div>
                            )}
                          </Col>

                          {Disability === '1' && (
                            <Col sm={12} md={4} className="mt-md-2 mt-1">
                              <>
                                <label className="mt-md-3 mt-1 labelText">
                                  Describe Disability
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Describe your disability"
                                  value={DisabilityDescription}
                                  onChange={(e) =>
                                    setDisabilityDescription(e.target.value)
                                  }
                                  required
                                />
                              </>
                            </Col>
                          )}
                        </Row>

                        <Row
                          className="mt-3"
                          style={{ display: 'flex', justifyContent: 'end' }}
                        >
                          <button
                            className="fs-5 btn btn-primary nextBtn"
                            style={{
                              backgroundColor: '#0783d6',
                              color: 'black',
                              width: '120px',
                              border: '0px  ',
                            }}
                            type="button"
                            onClick={goToPreviousPage}
                          >
                            Previous
                          </button>
                          <button
                            type="button"
                            className="fs-5 btn btn-primary nextBtn"
                            style={{
                              backgroundColor: '#0783d6',
                              color: 'black',
                              width: '100px',
                              border: '0px  ',
                            }}
                            onClick={handleNextClick}
                          >
                            Next
                          </button>
                        </Row>
                      </div>
                    </div>
                  </>
                )}

                {/* =============Second Form Step============= */}
                {currentPage === 3 && (
                  <div id="step-3">
                    <div
                      className="px-md-5 px-2 my-4 shadow py-4"
                      style={{
                        backgroundColor: 'white',
                        borderRadius: '10px',
                      }}
                    >
                      <div className="row m-0">
                        <h2
                          className="room-change-title text-start mt-md-4 mt-2"
                          style={{ color: '#0783d6' }}
                        >
                          Educational Information
                        </h2>
                      </div>

                      <Row>
                        <Col sm={12} md={6} className="mt-md-2 mt-2">
                          <label className="mt-md-3 mt-1 labelText">
                            Last Year School/College Name{' '}
                          </label>
                          <input
                            maxLength={200}
                            type="text"
                            style={{ color: 'black' }}
                            required
                            className={`form-control ${
                              errors.PCollageName ? 'error-input' : ''
                            }`}
                            name="l_collagename"
                            value={PCollageName}
                            onChange={(e) => setPCollageName(e.target.value)}
                            placeholder="Last Year School/College Name"
                          />{' '}
                          {errors.PCollageName && (
                            <div className="error-message">
                              {errors.PCollageName}
                            </div>
                          )}
                        </Col>
                        <Col sm={12} md={6} className="mt-md-2 mt-2">
                          <label className="mt-md-3 mt-1 labelText">
                            Last Year Standard And Division
                          </label>
                          <input
                            maxLength={200}
                            type="text"
                            style={{ color: 'black' }}
                            required
                            className={`form-control ${
                              errors.StdDiv ? 'error-input' : ''
                            }`}
                            name="std"
                            value={StdDiv}
                            onChange={(e) => setStdDiv(e.target.value)}
                            placeholder=" Last Year Standard And Division
                      "
                          />{' '}
                          {errors.StdDiv && (
                            <div className="error-message">{errors.StdDiv}</div>
                          )}
                        </Col>
                      </Row>

                      <Row>
                        <Col sm={12} md={6} className="mt-md-2 mt-2">
                          <label className="mt-md-3 mt-1 labelText">
                            Current School/College Name{' '}
                          </label>
                          <input
                            maxLength={200}
                            style={{ color: 'black' }}
                            type="text"
                            required="required"
                            className={`form-control ${
                              errors.CCollageName ? 'error-input' : ''
                            }`}
                            name="collage_name"
                            value={CCollageName}
                            onChange={(e) => setCCollageName(e.target.value)}
                            placeholder=" Current School/College Name"
                          />{' '}
                          {errors.CCollageName && (
                            <div className="error-message">
                              {errors.CCollageName}
                            </div>
                          )}
                        </Col>

                        <Col sm={12} md={6} className="mt-md-2 mt-2">
                          <label className="mt-md-3 mt-1 labelText">
                            Current Standard and Division
                          </label>
                          <input
                            maxLength={200}
                            style={{ color: 'black' }}
                            type="text"
                            required="required"
                            className={`form-control ${
                              errors.CurrentStd ? 'error-input' : ''
                            }`}
                            name="nextyearcollagename"
                            value={CurrentStd}
                            onChange={(e) => setCurrentStd(e.target.value)}
                            placeholder="Current Standard and Division"
                          />
                          {errors.CurrentStd && (
                            <div className="error-message">
                              {errors.CurrentStd}
                            </div>
                          )}
                        </Col>
                      </Row>

                      <Row>
                        <Col sm={12} md={6} className="mt-md-2 mt-2">
                          <label className="mt-md-3 mt-1 labelText">
                            Did you stay in sangli jain boarding last year?
                          </label>
                          <select
                            className="form-select"
                            name="Profeciency"
                            style={{ color: 'black' }}
                            value={Profeciency}
                            onChange={(e) => setProfeciency(e.target.value)}
                            required
                          >
                            <option value>Select</option>
                            <option value="1">Yes</option>
                            <option value="2">No</option>
                          </select>
                          {errors.Profeciency && (
                            <div className="error-message">
                              {errors.Profeciency}
                            </div>
                          )}
                        </Col>

                        <Col sm={12} md={6} className="mt-md-2 mt-2">
                          <label className="mt-md-3 mt-1 labelText">
                            Have you received a Scholarship from D B Jain Sabha
                            ?
                          </label>
                          <select
                            className="form-select"
                            style={{ color: 'black' }}
                            name="fellowship"
                            value={Fellowship}
                            onChange={(e) => setFellowship(e.target.value)}
                            required
                          >
                            <option value>Select</option>
                            <option value="1">Yes</option>
                            <option value="2">No</option>
                          </select>
                          {errors.Fellowship && (
                            <div className="error-message">
                              {errors.Fellowship}
                            </div>
                          )}
                        </Col>
                      </Row>

                      <Row
                        className="mt-3"
                        style={{ display: 'flex', justifyContent: 'end' }}
                      >
                        <button
                          className="fs-5 btn btn-primary nextBtn"
                          style={{
                            backgroundColor: '#0783d6',
                            color: 'black',
                            width: '120px',
                            border: '0px  ',
                          }}
                          type="button"
                          onClick={goToPreviousPage}
                        >
                          Previous
                        </button>
                        <button
                          className="fs-5 btn btn-primary nextBtn"
                          style={{
                            backgroundColor: '#0783d6',
                            color: 'black',
                            width: '100px',
                            border: '0px  ',
                          }}
                          onClick={handleNextClick1}
                          type="submit"
                        >
                          Next
                        </button>
                      </Row>
                    </div>
                  </div>
                )}

                {/* =============Photo Upload Step============= */}
                {currentPage === 4 && (
                  <div id="step-4">
                    <div
                      className="mx-2 mx-md-4 px-md-4 px-2 my-4 py-4 shadow"
                      style={{
                        backgroundColor: 'rgba(247, 246, 246, 0.781)',
                        borderRadius: '10px',
                      }}
                    >
                      <div className="row m-0">
                        <h2
                          className="room-change-title text-start mt-md-4 mt-2"
                          style={{ color: '#0783d6' }}
                        >
                          Upload Document
                        </h2>
                      </div>

                      <div>
                        <form
                          className="mt-3"
                          method="post"
                          onsubmit="return validateForm()"
                          validate
                        >
                          <Row>
                            <Col md={2}></Col>
                            <Col md={8}>
                              <Row style={{ display: 'flex' }}>
                                <Row
                                  className="mt-md-2 mt-2 "
                                  style={{ display: 'flex' }}
                                >
                                  <Col md={6}>
                                    <label className="mt-md-3 mt-1 labelText">
                                      <b>Student's Aadhar card :</b>
                                    </label>
                                  </Col>
                                  <Col md={6}>
                                    <input
                                      type="file"
                                      className="w-100"
                                      onChange={(e) => {
                                        const file = e.target.files[0]
                                        if (
                                          file &&
                                          file.size > 2 * 1024 * 1024
                                        ) {
                                          alert(
                                            'File size should not exceed 2MB',
                                          )
                                          e.target.value = null // Reset the file input
                                          return
                                        }
                                        setAdharCard(file)
                                      }}
                                      accept=".png , .jpeg , .jpg"
                                      required
                                    />
                                  </Col>
                                </Row>

                                <Row
                                  className="mt-md-2 mt-2"
                                  style={{ display: 'flex' }}
                                >
                                  <Col md={6}>
                                    <label className="mt-md-3 mt-1 labelText">
                                      <b>Student's Photo :</b>
                                    </label>
                                  </Col>
                                  <Col md={6}>
                                    <input
                                      type="file"
                                      className="w-100"
                                      name="files"
                                      multiple
                                      accept=".png , .jpeg , .jpg"
                                      onChange={(e) => {
                                        const file = e.target.files[0]
                                        if (
                                          file &&
                                          file.size > 2 * 1024 * 1024
                                        ) {
                                          alert(
                                            'File size should not exceed 2MB',
                                          )
                                          e.target.value = null
                                          return
                                        }
                                        setPhoto(file)
                                      }}
                                      data-max-files={3}
                                      required
                                    />
                                  </Col>
                                </Row>

                                <Row
                                  className="mt-md-2 mt-2 "
                                  style={{ display: 'flex' }}
                                >
                                  <Col md={6}>
                                    <label className="mt-md-3 mt-1 labelText">
                                      <b>Parent's Photo :</b>
                                    </label>
                                  </Col>
                                  <Col md={6}>
                                    <input
                                      type="file"
                                      className="w-100"
                                      multiple
                                      onChange={(e) => {
                                        const file = e.target.files[0]
                                        if (
                                          file &&
                                          file.size > 2 * 1024 * 1024
                                        ) {
                                          alert(
                                            'File size should not exceed 2MB',
                                          )
                                          e.target.value = null
                                          return
                                        }
                                        setParentPhoto(file)
                                      }}
                                      accept=".png , .jpeg , .jpg"
                                      data-max-files={3}
                                      required
                                    />
                                  </Col>
                                </Row>

                                <Row
                                  className="mt-md-2 mt-2"
                                  style={{ display: 'flex' }}
                                >
                                  <Col md={6}>
                                    <label className="mt-md-3 mt-1 labelText">
                                      <b>
                                        Student's School Leaving Certificate :
                                      </b>
                                    </label>
                                  </Col>
                                  <Col md={6}>
                                    <input
                                      type="file"
                                      className="w-100"
                                      multiple
                                      accept=".png , .jpeg , .jpg"
                                      onChange={(e) => {
                                        const file = e.target.files[0]
                                        if (
                                          file &&
                                          file.size > 2 * 1024 * 1024
                                        ) {
                                          alert(
                                            'File size should not exceed 2MB',
                                          )
                                          e.target.value = null
                                          return
                                        }
                                        setMarkList(file)
                                      }}
                                      data-max-files={3}
                                      required
                                    />
                                  </Col>
                                </Row>

                                <Row
                                  className="mt-md-2 mt-2 "
                                  style={{ display: 'flex' }}
                                >
                                  <Col md={6}>
                                    <label className="mt-md-3 mt-1 labelText">
                                      <b>
                                        Current Year School/Clg Admission
                                        Receipt :
                                      </b>
                                    </label>
                                  </Col>
                                  <Col md={6}>
                                    <input
                                      type="file"
                                      className="w-100"
                                      multiple
                                      onChange={(e) => {
                                        const file = e.target.files[0]
                                        if (
                                          file &&
                                          file.size > 2 * 1024 * 1024
                                        ) {
                                          alert(
                                            'File size should not exceed 2MB',
                                          )
                                          e.target.value = null
                                          return
                                        }
                                        setProficiencyDoc(file)
                                      }}
                                      accept=".png , .jpeg , .jpg"
                                      data-max-files={3}
                                      required
                                    />
                                  </Col>
                                </Row>
                              </Row>
                            </Col>
                            <Col md={2}></Col>
                          </Row>

                          <Row
                            className="mt-3"
                            style={{ display: 'flex', justifyContent: 'end' }}
                          >
                            <button
                              className="fs-5 btn btn-primary nextBtn"
                              style={{
                                backgroundColor: '#0783d6',
                                color: 'black',
                                width: '100px',
                                border: '0px  ',
                              }}
                              type="button"
                              onClick={handleup}
                              disabled={!validateFormup()}
                            >
                              Next
                            </button>
                          </Row>
                        </form>
                      </div>
                    </div>
                  </div>
                )}

                {/* =============Payment Photo Upload Step============= */}
                {currentPage === 5 && (
                  <div id="step-5">
                    <div
                      className="mx-2 mx-md-4 px-md-4 px-2 my-4 py-4 shadow"
                      style={{
                        backgroundColor: 'rgba(247, 246, 246, 0.781)',
                        borderRadius: '10px',
                      }}
                    >
                      <div className="row m-0">
                        <h2
                          className="room-change-title text-start mt-md-4 mt-2"
                          style={{ color: '#0783d6' }}
                        >
                          Registration(Prospectus) Fee
                        </h2>
                      </div>

                      <div>
                        <form method="post">
                          <div>
                            <h4
                              style={{ color: '#45a049' }}
                              className="mb-3 text-center mt-3"
                            >
                              Scan & Pay Registration Fee.(Rs.50)
                            </h4>
                            <div className="text-center">
                              <img
                                src={qrcode}
                                style={{ height: '130px', width: '130px' }}
                              />
                            </div>
                            <div className="text-center">
                              <Button
                                className="mt-3 mt-md-2"
                                style={{
                                  background: 'black',
                                  color: 'white',
                                  border: '0px',
                                }}
                                onClick={downloadQRCode}
                              >
                                Download QR Code
                              </Button>
                            </div>

                            <Row className="mt-3">
                              <Col md={6}>
                                <div>
                                  <Row className="mt-md-2 mt-2 ">
                                    <Col md={4}>
                                      <label>UPI ID :</label>
                                    </Col>
                                    <Col md={8}>
                                      <p>getepay.svccblqr432819@icici</p>
                                    </Col>
                                  </Row>

                                  <Row className="mt-md-2 mt-2 ">
                                    <Col md={4}>
                                      <label>Account Name :</label>
                                    </Col>
                                    <Col md={8}>
                                      <p>
                                        SHETH RAMDHANAJI DAVADA JAIN BOARDING
                                        SANGLI
                                      </p>
                                    </Col>
                                  </Row>

                                  <Row className="mt-md-2 mt-2 ">
                                    <Col md={4}>
                                      <label>Account No :</label>
                                    </Col>
                                    <Col md={8}>
                                      <p>120503130002085</p>
                                    </Col>
                                  </Row>

                                  <Row className="mt-md-2 mt-2 ">
                                    <Col md={4}>
                                      <label>Bank Name/Branch:</label>
                                    </Col>
                                    <Col md={8}>
                                      <p>SVC CO-OPERATIVE BANK LTD / SANGLI</p>
                                    </Col>
                                  </Row>

                                  <Row className="mt-md-2 mt-2 ">
                                    <Col md={4}>
                                      <label>IFSC Code :</label>
                                    </Col>
                                    <Col md={8}>
                                      <p>SVCB0000205</p>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                              <Col
                                md={6}
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignContent: 'center',
                                }}
                              >
                                <div>
                                  <Row
                                    className="mt-md-2 mt-2"
                                    style={{ display: 'flex' }}
                                  >
                                    <Col md={6}>
                                      <label>Payment Mode :</label>
                                    </Col>
                                    <Col md={6}>
                                      <select
                                        id="paymentMode"
                                        style={{ height: '39px' }}
                                        required="required"
                                        className={`w-100 rounded ${
                                          errors.paymentMode
                                            ? 'error-input'
                                            : ''
                                        }`}
                                        value={paymentMode}
                                        onChange={(e) =>
                                          setPaymentMode(e.target.value)
                                        }
                                      >
                                        <option value="">
                                          Select Payment Mode
                                        </option>
                                        <option value="1">Online</option>
                                        <option value="2">Cash</option>
                                      </select>
                                      {errors.paymentMode && (
                                        <div className="error-message">
                                          {errors.paymentMode}
                                        </div>
                                      )}
                                    </Col>
                                  </Row>

                                  <Row
                                    className="mt-md-2 mt-2 "
                                    style={{ display: 'flex' }}
                                  >
                                    <Col md={6}>
                                      {paymentMode === '1' ? (
                                        <label
                                          className=" mt-2"
                                          htmlFor="transactionId"
                                        >
                                          Transaction ID:
                                        </label>
                                      ) : (
                                        <label
                                          className=" mt-2"
                                          htmlFor="transactionId"
                                        >
                                          Cash Receipt No:
                                        </label>
                                      )}
                                    </Col>
                                    <Col md={6}>
                                      <input
                                        id="mobileNumber"
                                        type="text"
                                        required="required"
                                        className={`w-100 ${
                                          errors.taxId ? 'error-input' : ''
                                        }`}
                                        value={taxId}
                                        onChange={(e) =>
                                          setTaxid(e.target.value)
                                        }
                                        placeholder={
                                          paymentMode === '1'
                                            ? 'Enter transaction ID...'
                                            : 'Enter Cash Receipt No...'
                                        }
                                      />{' '}
                                      {errors.taxId && (
                                        <div className="error-message">
                                          {errors.taxId}
                                        </div>
                                      )}
                                    </Col>
                                  </Row>

                                  <Row
                                    className="mt-md-2 mt-2 "
                                    style={{ display: 'flex' }}
                                  >
                                    <Col md={6}>
                                      <label className="mt-md-3 mt-1">
                                        <b>Upload Paid Image :</b>
                                      </label>
                                    </Col>
                                    <Col md={6}>
                                      <input
                                        type="file"
                                        name="files"
                                        className="w-100"
                                        multiple
                                        accept=".png , .jpeg , .jpg"
                                        data-max-files={3}
                                        onChange={(e) => {
                                          const file = e.target.files[0]
                                          if (
                                            file &&
                                            file.size > 2 * 1024 * 1024
                                          ) {
                                            alert(
                                              'File size should not exceed 2MB',
                                            )
                                            e.target.value = null
                                            return
                                          }
                                          setTax(file)
                                        }}
                                        required
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                          </div>

                          <Row
                            className="mt-3"
                            style={{ display: 'flex', justifyContent: 'end' }}
                          >
                            <button
                              className="fs-5 btn btn-primary nextBtn"
                              style={{
                                backgroundColor: '#0783d6',
                                color: 'black',
                                width: '120px',
                                border: '0px  ',
                              }}
                              type="button"
                              onClick={goToPreviousPage}
                            >
                              Previous
                            </button>
                            <button
                              className="fs-5 btn btn-primary nextBtn"
                              style={{
                                backgroundColor: '#0783d6',
                                color: 'black',
                                width: '100px',
                                border: '0px  ',
                              }}
                              type="button"
                              onClick={handleNextClick}
                              disabled={!taxId || !tax || !paymentMode}
                            >
                              Next
                            </button>
                          </Row>
                        </form>
                      </div>
                    </div>
                  </div>
                )}
              </form>

              {/* =============Check and Proceed Step============= */}
              {currentPage === 6 && (
                <div id="step-6">
                  <div
                    className="mx-2 mx-md-4 px-md-5 px-2 my-4 py-4 shadow"
                    style={{
                      backgroundColor: 'rgba(247, 246, 246, 0.781)',
                      borderRadius: '10px',
                    }}
                  >
                    <div className="row m-0">
                      <h2
                        className="room-change-title text-start mt-md-4 mt-2"
                        style={{ color: '#0783d6' }}
                      >
                        Information
                      </h2>
                    </div>

                    <div>
                      <form
                        method="post"
                        onsubmit="return validateForm()"
                        validate
                      >
                        <Row className="mt-3 mt-md-5">
                          {/* <Col md={3}></Col> */}
                          <Col md={12}>
                            <ul style={{ lineHeight: '35px' }}>
                              <li>
                                बोर्डिंग मेस अनिवार्य आहे व मेस चे सर्व नियम मला
                                मान्य आहेत.
                              </li>
                              <li>येत्या शनिवारी/रविवारी मुलाखतीस यावे. </li>
                              <li>
                                विद्यार्थ्यास स्वखर्चाने मुलाखतीस यावे लागेल.
                              </li>

                              <li>
                                विद्यार्थ्यांने मुलाखतीस येताना भरलेल्या अर्जाची
                                (PDF) कलर प्रिंट व अपलोड केलेल्या डॉक्युमेंटस ची
                                झेरॉक्स कॉपी घेऊन येणे.{' '}
                              </li>
                              <li>
                                विद्यार्थ्यांस बोर्डिंग मध्ये प्रवेश देण्याचा /
                                नाकारण्याचा अधिकार सर्वस्वी बोर्डिंग
                                मॅनेजमेंटच्या हाती राहील .{' '}
                              </li>
                            </ul>
                            <div className="ms-2">
                              <input
                                type="checkbox"
                                id="agreeCheckbox"
                                onChange={toggleSubmitButton}
                              />
                              <label htmlFor="agreeCheckbox">
                                &nbsp; &nbsp; वरील भरलेली सर्व महिती व कागदपत्रे
                                बरोबर असून मला बोर्डिंगचे सर्व नियम व अटी मान्य
                                आहेत.
                              </label>
                            </div>
                          </Col>
                          {/* <Col md={3}></Col> */}
                        </Row>

                        <Row
                          className="mt-3"
                          style={{ display: 'flex', justifyContent: 'end' }}
                        >
                          {loading ? (
                            <div
                              style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100vw',
                                height: '100vh',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)', // optional dim background
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 9999,
                              }}
                            >
                              <img
                                src={loadingImg}
                                alt="Loading..."
                                style={{
                                  width: '120px',
                                  height: '120px',
                                }}
                              />
                              <p
                                style={{
                                  fontSize: '18px',
                                  fontWeight: '500',
                                  color: 'red',
                                  backgroundColor: 'white',
                                }}
                              >
                                (Please wait while loading. Do not press
                                'Refresh' or 'Back' button)
                              </p>
                            </div>
                          ) : (
                            <button
                              className="fs-5 btn btn-primary nextBtn"
                              style={{
                                backgroundColor: '#0783d6',
                                color: 'black',
                                width: '150px',
                                border: '0px',
                              }}
                              type="button"
                              onClick={onClickGeneratePDF}
                            >
                              Submit
                            </button>
                          )}
                        </Row>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-12 col-lg-1"></div>
          </div>
        </div>

        <footer
          className="fixed-footer fixed-bottom"
          style={{ backgroundColor: '#86caf7' }}
        >
          <div className="container footerr text-center py-2">
            <span>
              &copy; 2025 Sheth R. D. Davada Digambar Jain Boarding, Sangli |
              Managed By : TechnoAarv Solution
            </span>
          </div>
        </footer>
      </section>
    </>
  )
}

export default RegForm
